module.exports = __webpack_public_path__ + "img/brand--ncr.e35367e9.svg";